import { render, staticRenderFns } from "./FacilityManagement.vue?vue&type=template&id=376bb229&scoped=true"
import script from "./FacilityManagement.vue?vue&type=script&lang=ts"
export * from "./FacilityManagement.vue?vue&type=script&lang=ts"
import style0 from "./FacilityManagement.vue?vue&type=style&index=0&id=376bb229&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376bb229",
  null
  
)

export default component.exports